/*
 * Copyright (C) 2025 Musarubra US LLC.  All Rights Reserved.
 */

import { Page } from './page-base';
import { OktaLoginWidget } from '../widgets/okta-login-widget';
// import { KeycloakLoginWidget } from '../widgets/keycloak-login-widget';
import { LoginWidget } from '../widgets/login-widget-base';
import { iamLogin } from '../main';
import { OktaWidgetElements } from '../elements/okta-widget-elements';
// import { KeycloakWidgetElements } from '../elements/keycloak-widget-elements';
import { iam } from '../iam';
import { WidgetElements } from '../elements/widget-elements-base';

export abstract class WidgetPage extends Page {
  protected loginWidget: LoginWidget;
  protected widgetElements: WidgetElements;

  constructor() {
    super();
    this.elements = this.widgetElements = /*iam.settings.keycloakBasedEnvironment ? new KeycloakWidgetElements() :*/ new OktaWidgetElements();
    this.loginWidget = /*iam.settings.keycloakBasedEnvironment ? new KeycloakLoginWidget(this.widgetElements) :*/ new OktaLoginWidget(this.widgetElements);
  }

  /**
   * Show or hide common fields
   * @param fields array of fields to show (others will be hidden)
   */
  public override showCommonFields(fields: string[]) {
    super.showCommonFields(fields);
    if (this.widgetElements.getAuthFooter()) { // not always present
      this.widgetElements.getAuthFooter().style.display = fields.indexOf('auth-footer') >= 0 ? 'block' : 'none';
    }
    document.getElementById('post-okta').style.display = fields.indexOf('post-okta') >= 0 ? '' : 'none';
  }

  public getUsername() {
    if (this.widgetElements.getUsernameField()) {
      return this.widgetElements.getUsernameField().value;
    } else if (document.getElementById('login_hint')) {
      return (document.getElementById('login_hint') as HTMLInputElement).value;
    } else if (iamLogin.parseQuery(iam.Token.getLocation().search).login_hint) {
      return iamLogin.parseQuery(iam.Token.getLocation().search).login_hint;
    } else if (iamLogin.parseQuery(iam.Token.getLocation().search).login) {
      return iamLogin.parseQuery(iam.Token.getLocation().search).login;
    } else if (window.localStorage.getItem('login_hint')) {
      return window.localStorage.getItem('login_hint');
    } else {
      return iamLogin.getEmailFromToken();
    }
  }
}
